import React from "react";
import BulkUploadFile from "../../components/BulkUploadFile";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as BulkCouponUploadActions from "../../store/actions/BulkCouponUpload";

const instructions = [
  "Please provide data as per the format in the sample file.",
  "Please try to open your sample csv file always with MS excel or google sheets but don't open with other editors.",
];

const BulkCouponUploadDashboard = ({ getBulkUploadUrl }) => {
  return (
    <BulkUploadFile
      instructions={instructions}
      btnDataTestID="BulkCouponUploadBtn"
      uploadUrl="/coupons/bulk/upload/ack"
      sampleURL="/sample/bulk_coupon_upload.csv"
      id="BulkCouponUploadModal"
      sendExtraAck={true}
      keyName="callback_key"
      heading="Bulk Coupon Upload"
      getUploadUrl={getBulkUploadUrl}
    />
  );
};

function mapDispatchToProps(dispatch) {
  return {
    getBulkUploadUrl: bindActionCreators(
      BulkCouponUploadActions.getUploadUrl,
      dispatch
    ),
  };
}

export default connect(null, mapDispatchToProps)(BulkCouponUploadDashboard);
